module.exports = __webpack_public_path__ + "img/logo.804a9586.png";